import {subscribe} from '../helpers/pubSub';
export default function() {
    // Override for Denali
    subscribe('requestPriceForm:submit', function(params) {
        if (!params || !params.formEl || !params.formData || !params.formData.salesforceWebCase) {
            return;
        }
        let actionURL = params.formEl.getAttribute('data-web-case-url');
        let topicValue = 'Product';
        var dataToSend = {
            //'debug': 1, // Only enable this during debugging mode
            //'debugEmail': 'test@mail.com', // Only enable this during debugging mode
            'orgid': params.formData.orgid,
            'recordType': params.formData.recordType,
            'RICSC_Maison__c': params.formData.RICSC_Maison__c,
            'email': params.formData.dwfrm_requestprice_customer_email || '',
            'name': params.formData.dwfrm_requestprice_customer_salutations_salutation[0].toUpperCase() + params.formData.dwfrm_requestprice_customer_salutations_salutation.substr(1).toLowerCase() + ' ' + params.formData.dwfrm_requestprice_customer_firstname + ' ' + params.formData.dwfrm_requestprice_customer_lastname,
            'phone': params.formData.dwfrm_requestprice_customer_phone || '',
            'RICCRC_Topic__c': topicValue,
            'description': params.formData.dwfrm_requestprice_customer_yourmessage,
            'RICCRC_Language__c': params.formData.RICCRC_Language__c,
            'RICCRC_CountryOfInteraction__c': params.formData.RICCRC_CountryOfInteraction__c
        };
        if (window.SFRA.SitePreferences.contactUsMarketingConsent) {
            dataToSend.contactUsMarketingConsent = params.formData.dwfrm_requestprice_customer_consectacceptance;
        } else {
            dataToSend.RICCRC_MarketingConsent__c = params.formData.dwfrm_requestprice_customer_consectacceptance;
        }

        if (actionURL) {
            $.ajax({
                url: actionURL,
                type: 'POST',
                data: dataToSend
            });
        }
    });

}
